"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return FileReference;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('FileReference');
let FileReference = class FileReference {
    static async insert(context, fileRefObj, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(fileRefObj, [
            'id',
            'storage',
            'file_url',
            'file_size',
            'fk_user_id',
            'source_id',
            'fk_model_id',
            'fk_column_id',
            'is_external',
            'deleted'
        ]);
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, insertObj);
        if (context.workspace_id && !insertObj.deleted) {
            await this.updateWorkspaceCache(context, insertObj.file_size);
        }
        return id;
    }
    // used when url downloaded
    static async updateById(context, id, fileRefObj, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(fileRefObj, [
            'storage',
            'file_url',
            'file_size',
            'fk_user_id',
            'source_id',
            'fk_model_id',
            'fk_column_id',
            'is_external',
            'deleted'
        ]);
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, updateObj, id);
        if (context.workspace_id && !updateObj.deleted) {
            await this.updateWorkspaceCache(context, updateObj.file_size);
        }
        return id;
    }
    static async delete(context, fileReferenceId, ncMeta = _Noco.default.ncMeta) {
        if (!fileReferenceId || Array.isArray(fileReferenceId) && fileReferenceId.length === 0) {
            return;
        }
        const fileReferences = Array.isArray(fileReferenceId) ? fileReferenceId : [
            fileReferenceId
        ];
        let fileReferencesSize = 0;
        try {
            fileReferencesSize = await FileReference.sumSize(context, {}, fileReferences, ncMeta);
        } catch (error) {
            fileReferencesSize = -1;
            logger.error('Error while summing file reference size');
            logger.error(error);
        }
        if (fileReferences.length === 1) {
            const fileReferenceObj = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, fileReferences[0]);
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, {
                deleted: true
            }, fileReferenceObj.id);
        } else {
            await ncMeta.bulkMetaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, {
                deleted: true
            }, fileReferences);
        }
        await this.updateWorkspaceCache(context, fileReferencesSize, true);
    }
    static async bulkDelete(context, condition, ncMeta = _Noco.default.ncMeta) {
        let fileReferencesSize = 0;
        try {
            fileReferencesSize = await FileReference.sumSize(context, condition, undefined, ncMeta);
        } catch (error) {
            fileReferencesSize = -1;
            logger.error('Error while summing file reference size');
            logger.error(error);
        }
        await ncMeta.bulkMetaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, {
            deleted: true
        }, null, condition);
        await this.updateWorkspaceCache(context, fileReferencesSize, true);
    }
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        const fileReferenceData = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILE_REFERENCES, id);
        return fileReferenceData && new FileReference(fileReferenceData);
    }
    static async updateWorkspaceCache(context, size, decrement = false) {
        if (context.workspace_id) {
            if (size === -1) {
                await _NocoCache.default.del('root', `${_globals.CacheScope.STORAGE_STATS}:workspace:${context.workspace_id}`);
            } else {
                await _NocoCache.default.incrHashField('root', `${_globals.CacheScope.STORAGE_STATS}:workspace:${context.workspace_id}`, _nocodbsdk.PlanLimitTypes.LIMIT_STORAGE_PER_WORKSPACE, decrement ? -(size != null ? size : 0) : size != null ? size : 0);
            }
        }
    }
    static async sumSize(context, condition, pkIn, ncMeta = _Noco.default.ncMeta) {
        const fileReferenceQb = ncMeta.knexConnection(_globals.MetaTable.FILE_REFERENCES).where(_extends({
            deleted: false,
            fk_workspace_id: context.workspace_id
        }, condition));
        if (pkIn) {
            fileReferenceQb.whereIn('id', pkIn);
        }
        const fileReferenceData = await fileReferenceQb.sum('file_size as totalSize').first();
        if (fileReferenceData) {
            return +fileReferenceData.totalSize;
        }
        return 0;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
